"use strict";

import $ from "jquery";
import Cookies from "js-cookie";

const COOKIES_ACCEPTED = "cookies_accepted";

const cookiesAccepted = function () {
  return Cookies.get(COOKIES_ACCEPTED) === "true";
};

const acceptCookies = function () {
  Cookies.set(COOKIES_ACCEPTED, "true", { expires: 3650 });
  $("#cookie-warning").hide();
};

$(document).on("turbolinks:load", function () {
  if (!cookiesAccepted()) {
    $("#cookie-warning").show();
    $("#cookie-warning-accept").on("click", acceptCookies);
  }
});
